// extracted by mini-css-extract-plugin
export var eventHeader = "eventTemplate-module--event-header--1mHph";
export var eventImageWrapper = "eventTemplate-module--event-image-wrapper--XfsKu";
export var eventText = "eventTemplate-module--event-text--0Lqg5";
export var eventWrapper = "eventTemplate-module--event-wrapper--gpGOX";